import { CheckboxGroupWrapper } from '@kizi/comparator-components';
import { P } from '@kizi/core-components';
import React from 'react';

export const AdditionalChannels = () => {
  return (
    <>
      <P variant="bodyImportant">{'Zenderpakketten'}</P>
      <CheckboxGroupWrapper
        id="AdditionalChannels"
        _fieldName="overview.additionalChannels"
        options={[
          { label: 'Ziggo Sport Totaal', value: 'ziggoSport' },
          { label: 'ESPN Compleet', value: 'espn' },
        ]}
        selectedOptions={[]}
        labelProps={{ fontFamily: 'body' }}
      />
    </>
  );
};
